module.exports = __webpack_public_path__ + "img/horizontal_6_1_pp1_8019.35f89e8a.png";